// extracted by mini-css-extract-plugin
export default {"content":"content___Ybpss","contentLeft":"contentLeft___fLb1w","contentRight":"contentRight___gaKu_","previewCard":"previewCard___A4rZC","imgPreview":"imgPreview___XnEdH"};